/** HTTP header name; must match gui-server. */
export const QUICK_SIM_CONTEXT_HEADER = "x-qlector-quick-sim-context";

/** Allowed values for quick-sim observability; must match gui-server `ALLOWED_QUICK_SIM_CONTEXT_HEADERS`. */
export type QuickSimUseCase =
    /** Schedule an unscheduled operation */
    | "operation-schedule"
    /** Unschedule a scheduled operation */
    | "operation-unschedule"
    /** Move an operation to a different position */
    | "operation-move"
    /** Update operation quantity or capacity, (un)freeze, (un)fix */
    | "operation-update"
    /** Ignore single operation or multiple operations of the same order */
    | "operations-ignore"
    /** Unignore single operation or multiple operations of the same order */
    | "operations-unignore"
    /** Update multiple operations, e.g. make all operations on the line 24/7, (un)freeze whole line */
    | "operations-update"
    /** Unschedule all scheduled operations */
    | "operations-unschedule-all"
    /** Initialize plan with short horizon */
    | "plan-initialize-short"
    /** Initialize plan with long horizon */
    | "plan-initialize-long"
    /** Initialize plan export */
    | "plan-initialize-export"
    /** Update multiple operations, e.g. change sequence, start time, line, scheduled status, after plan optimization */
    | "plan-update"
    /** Enable or disable shifts */
    | "shifts-update";

/**
 * Per-request headers for POST /reports/quick-simulation-sync (omit when no use case).
 */
export function buildQuickSimSyncRequestHeaders(
    useCase: QuickSimUseCase | undefined
): Record<string, string> | undefined {
    if (useCase === undefined) {
        return undefined;
    }

    return { [QUICK_SIM_CONTEXT_HEADER]: useCase };
}
